import data from "../../../../../packages/react/src/PageHeader/PageHeader.docs.json";
import * as React from 'react';
export default {
  data,
  React
};